// extracted by mini-css-extract-plugin
module.exports = {"video":"style_video__ivd1f","videoInner":"style_videoInner__X6YYR"};